import mmq from 'matchmediaquery'
import config from '../../../tailwind.config'

export function isScreenSize (size) {
  const screens = config.theme.screens

  if (screens[size] === undefined) {
    return false
  }

  return mmq(`(min-width: ${screens[size]})`).matches
}
